import { SharedState } from 'app/types-shared';

export const getCompanyReportAdminAccess =
  (sharedState: SharedState): boolean => sharedState?.access?.adminPanel?.companyReport?.administrationCentral;
